<template>
  <div class="main-content">
    <section class="section">
      <PageHeaderNoAction>
        <template slot="buttons">
          <div class="mt-3 mt-lg-0 mr-lg-3">
            <button type="button" class="btn btn-primary legitRipple" @click="saveBtnClick()">
              <i class="fas fa-caret-right mr-2"></i>Save
            </button>
          </div>
          <div class="mt-3 mt-lg-0 mr-lg-3">
            <button type="button" class="btn btn-light legitRipple" @click="cancelBtnClick()">
              <i class="far fa-window-close mr-2"></i>Cancel
            </button>
          </div>
        </template>
      </PageHeaderNoAction>
      <div class="section-body">
        <div class="card">
          <div class="card-body">
              <Textbox  title="Workflow Name" labelwidth="2" maxlength="50" v-model="formData.name" :readonly="true" />
              <Textbox title="From" labelwidth="2" maxlength="250" v-model="formData.from" :helptext="'Default to ' + $helper.getParam('DEFAULT_EMAIL_FROM') + ', input another email to override.'" />
              <Textbox  title="CC" labelwidth="2" maxlength="250" v-model="formData.cc" helptext="Comma separated email address or role name." />
              <CheckBox id="cchistory" title="Copied actioned users" labelwidth="2" maxlength="250" v-model="formData.cc_history" :options="[{ Key: true, Value: ''}]" helptext="Copied all users that have actioned in the past for this workflow." />
              <Textbox id="subject" title="Subject" labelwidth="2" maxlength="200" v-model="formData.subject" :required="true" />
              <WfSelect title="Select Action" labelwidth="2"  v-model="formData.wf_pcikers" :delayLoad="true"/>
              <RichText title="Message"  v-model="formData.body_text"/>
           
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<style lang="scss">
// @import "@/assets/scss/main.scss";
</style>
<script>
import Vue from "vue";
import api from "@/api";
import config from "@/config";
import helper from "@/vueHelper";
import WfSelect from "@/components/wfselect"

export default {
  title: "Email",
  access_code: "G_MT10",
  hidden: true,
  data() {
    return {
      formData: {},
    };
  },
  components:{
    WfSelect
  },
  mounted() {
   this.loadForm();
  },
  methods: {
    cancelBtnClick(){
      this.$router.go(-1);
    },
    loadForm(){
       helper.loading();
    api.request(
      this,
      "post",
      "/system_maintenance/emailTemplateLoad",
      {
        SessionID: helper.getSessionID(),
        LocaleCode: helper.getLocaleCode(),
        Parameters: {
          id: this.$route.params.id
        }
      },

      function(r) {
        this.formData = r.data.formData;
        helper.done();
      },
      function(r) {
         helper.done();
      }
    );
    },
    saveBtnClick(){
       helper.loading();
    api.request(
      this,
      "post",
      "/system_maintenance/emailTemplateSave",
      {
        SessionID: helper.getSessionID(),
        LocaleCode: helper.getLocaleCode(),
        Parameters: {
          formData:this.formData
        }
      },

      function(r) {
        helper.clearData(this);
        this.loadForm();
      },
      function(r) {
         helper.done();
      }
    );
    }
  },
  
};
</script>
<style >
.section-body {
  padding-top: 100px;
}
.errormsg {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
}
.correctname {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #22b60e;
}
</style>